var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-switcher"},[_c('Select',{attrs:{"name":"languages","label":"Select language","label-hidden":"","options":_vm.selectOptions,"size":"extra-small"},on:{"change":_vm.setLanguage},model:{value:(_vm.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$i18n, "locale", $$v)},expression:"$i18n.locale"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }